import { render, staticRenderFns } from "./entity-form-provider.vue?vue&type=template&id=89dc4c2e&scoped=true&"
import script from "./entity-form-provider.ts?vue&type=script&lang=ts&"
export * from "./entity-form-provider.ts?vue&type=script&lang=ts&"
import style0 from "./entity-form-provider.scss?vue&type=style&index=0&id=89dc4c2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89dc4c2e",
  null
  
)

export default component.exports